import { useEffect, useRef, useState } from "react";

export const Counter = ({ to, suffix, label, i }) => {
  const ref = useRef(null);
  const [value, setValue] = useState(to);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === "undefined") return undefined;
    if (el.getBoundingClientRect().top < window.innerHeight) return undefined;
    setValue(0);
    let raf = 0;
    const io = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      io.disconnect();
      const start = performance.now();
      const tick = (now) => {
        const p = Math.min(1, (now - start) / 1800);
        setValue(Math.round(to * (1 - Math.pow(1 - p, 3))));
        if (p < 1) raf = requestAnimationFrame(tick);
      };
      raf = requestAnimationFrame(tick);
    }, { threshold: 0.2 });
    io.observe(el);
    return () => {
      io.disconnect();
      cancelAnimationFrame(raf);
      setValue(to);
    };
  }, [to]);

  return (
    <div ref={ref} className="border-t border-white/15 pt-6 sm:pt-8" data-testid={`counter-${i}`}>
      <p className="font-display text-6xl font-bold leading-none text-white tabular-nums sm:text-7xl lg:text-8xl">
        {value}<span className="text-terra">{suffix}</span>
      </p>
      <p className="mt-4 max-w-[16rem] text-sm leading-relaxed text-slate-300">{label}</p>
    </div>
  );
};
